// Export utilities for PDF and CSV
export const exportToPDF = (transactions, stats) => {
  const content = `
FINANCIAL REPORT
Generated: ${new Date().toLocaleDateString()}

SUMMARY
Total Balance: $${stats.totalBalance.toFixed(2)}
Monthly Income: $${stats.monthlyIncome.toFixed(2)}
Monthly Expenses: $${stats.monthlyExpenses.toFixed(2)}
Net Savings: $${stats.netBalance.toFixed(2)}

TRANSACTIONS
${transactions.map(t => 
  `${t.date} | ${t.description} | ${t.category} | $${t.amount.toFixed(2)}`
).join('\n')}
  `;
  
  const blob = new Blob([content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `financial-report-${new Date().toISOString().split('T')[0]}.txt`;
  a.click();
  URL.revokeObjectURL(url);
};

export const exportToCSV = (transactions) => {
  const headers = ['Date', 'Description', 'Category', 'Amount', 'Type'];
  const csvContent = [
    headers.join(','),
    ...transactions.map(t => [
      t.date,
      `"${t.description}"`,
      t.category,
      t.amount,
      t.amount > 0 ? 'Income' : 'Expense'
    ].join(','))
  ].join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `transactions-${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

export const exportTaxReport = (transactions) => {
  const taxYear = new Date().getFullYear();
  const taxTransactions = transactions.filter(t => 
    new Date(t.date).getFullYear() === taxYear
  );
  
  const income = taxTransactions.filter(t => t.amount > 0);
  const expenses = taxTransactions.filter(t => t.amount < 0);
  
  const content = `
TAX REPORT ${taxYear}
Generated: ${new Date().toLocaleDateString()}

INCOME SUMMARY
Total Income: $${income.reduce((sum, t) => sum + t.amount, 0).toFixed(2)}

EXPENSE SUMMARY  
Total Expenses: $${Math.abs(expenses.reduce((sum, t) => sum + t.amount, 0)).toFixed(2)}

DETAILED INCOME
${income.map(t => 
  `${t.date} | ${t.description} | $${t.amount.toFixed(2)}`
).join('\n')}

DETAILED EXPENSES
${expenses.map(t => 
  `${t.date} | ${t.description} | $${Math.abs(t.amount).toFixed(2)}`
).join('\n')}
  `;
  
  const blob = new Blob([content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `tax-report-${taxYear}.txt`;
  a.click();
  URL.revokeObjectURL(url);
};

// Lightweight Excel export using HTML table compatible with Excel
export const exportToExcel = (transactions) => {
  const headers = ['Date', 'Description', 'Category', 'Amount', 'Type'];
  const rows = transactions.map(t => [
    t.date,
    escapeHtml(t.description || ''),
    escapeHtml(t.category || ''),
    t.amount,
    t.amount > 0 ? 'Income' : 'Expense'
  ]);

  const table = `
    <table>
      <thead>
        <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
      </thead>
      <tbody>
        ${rows.map(r => `<tr>${r.map(c => `<td>${c}</td>`).join('')}</tr>`).join('')}
      </tbody>
    </table>
  `;
  const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>${table}</body></html>`;
  const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `transactions-${new Date().toISOString().split('T')[0]}.xls`;
  a.click();
  URL.revokeObjectURL(url);
};

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}